import React,{useState} from 'react';
import '../../App.css';
import {Form,Container,Row,Col} from "react-bootstrap";


function Scans(props){
    const [mriName,setMRI] = useState(null)
    const [MIBG,setMIBG] = useState(null)
    const [FDG,setFDG] = useState()
    const extension="application/jpg, .jpg"
    return(
        <div>
            <h4>Patient Scans</h4>
            <br/>
            <Form>
                {/*<Form.Group >*/}
                {/*    <Form.Label>Brain MRI -  3Tesla</Form.Label>*/}
                {/*    <Form.File label={"MRI SCAN"} custom/>*/}
                {/*</Form.Group>*/}
                <Form.Group>
                    <Form.Label>Brain MRI</Form.Label>
                    <Form.File label={mriName ||'Please Select'}   custom={true}onChange={(event)=>{
                        setMRI(event.target.files[0].name)
                        props.files(event,'BrainMRI')

                    }} accept={extension}  multiple={false}/>
                </Form.Group>


                <Form.Group>
                    <Form.Label>Heart MIBG</Form.Label>
                        <Form.File label={MIBG||'Please select'}   custom={true}onChange={(event)=>{
                            setMIBG(event.target.files[0].name)
                            props.files(event,'MIBG')

                        }} accept={extension}   multiple={false}/>
                </Form.Group>



                    <Form.Group>
                    <Form.Label>Heart MIBG</Form.Label>
                    <Form.File label={FDG||'Please select'}   custom={true}onChange={(event)=>{
                        setFDG(event.target.files[0].name)
                        props.files(event,'FDG')

                    }} accept={extension} multiple={false} />
                    </Form.Group>

                    {/*<Form.File id="file"custom >*/}
                    {/*    <Form.File.Input onChange={(event)=>{*/}
                    {/*        setFDG(event.target.files[0].name)*/}
                    {/*        props.files(event)*/}

                    {/*    }} accept={"application/dicom, .jpg"} />*/}
                    {/*    <Form.File.Label>*/}
                    {/*        { FDG||'Please select'}*/}
                    {/*    </Form.File.Label>*/}
                    {/*    <Form.Control.Feedback type="valid">OK</Form.Control.Feedback>*/}
                    {/*</Form.File>*/}


            </Form>

        </div>
    )
}

export default Scans;